import React from 'react';
import LoggerService from 'services/LoggerService';
import { loggerApi } from 'store/api';

class ErrorBoundary extends React.Component {
  protected logger = new LoggerService(loggerApi);

  public componentDidCatch(error: Error) {
    this.logger.log(error);
  }

  public render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
